<template>
  <v-bottom-sheet
      v-model="visible"
      v-bind="$attrs"
      no-click-animation
      content-class="bottom-sheet min-height-auto"
  >
    <slot :close="close">
      <v-card style="min-height: 50vh">
        <v-card-title>
          <slot name="card-title"></slot>
          <v-spacer />
          <v-btn icon @click="close"><IconClose /></v-btn>
        </v-card-title>
        <slot name="card-body"></slot>
      </v-card>
    </slot>
  </v-bottom-sheet>
</template>

<script>

export default {
  name: 'BottomSheet',
  data: () => ({
    visible: false
  }),
  watch: {
    visible (nV) {
      this.$emit('change', nV)
    }
  },
  methods: {
    open () {
      this.visible = !this.visible
    },
    close () {
      this.visible = !this.visible
    }
  }
}
</script>
